(() => {
  const activateLocale = (target) => {
    const form = target.closest('form');
    if (!form || target.classList.contains('is-active')) return;

    const input = form.querySelector('input[name="locale_code"]');
    if (!input) return;

    form.querySelectorAll('[data-aerfa-locale]').forEach((item) => {
      item.classList.toggle('is-active', item === target);
      item.toggleAttribute('aria-current', item === target);
    });

    input.value = target.dataset.aerfaLocale;
    document.documentElement.classList.add('aerfa-language-transition');

    window.setTimeout(() => {
      HTMLFormElement.prototype.submit.call(form);
    }, 260);
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target.closest('[data-aerfa-locale]');
      if (!target) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      activateLocale(target);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const target = event.target.closest('[data-aerfa-locale]');
      if (!target || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      activateLocale(target);
    },
    true
  );
})();
